import React from "react";
import * as Images from "../../../utilities/images";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useHandleSmallBusinessPlans } from "../../../hooks/useHandleSmallBusinessPlans";

const SmallUserPlans = () => {
  const isProduction = process.env.REACT_APP_ENV === "production";
  const {
    smallBusinessPlansSelector,
    loading,
    selectedPlan,
    editMode,
    formData,
    additionalInfoItems,
    editingInfoItem,
    newInfoItem,
    showAddForm,
    handlePlanChange,
    handleInputChange,
    handleEditToggle,
    handleSave,
    handleAddInfoItem,
    handleDeleteInfoItem,
    handleEditInfoItem,
    handleUpdateInfoItem,
    handleInfoItemChange,
    handleInfoItemBoldToggle,
    handleNewInfoItemChange,
    handleNewInfoItemBoldToggle,
    setEditingInfoItem,
    setShowAddForm,
  } = useHandleSmallBusinessPlans();

  if (loading) {
    return (
      <div className="d-flex justify-content-center py-5 mx-auto">
        <div className="spinner-grow text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <>
      <div className="containerBox adminDashbord">
        <div className="searchFilter">
          <h3 className="headTxtBlueSmall mb-3">Small Business Plans</h3>
        </div>

        <form className="form mt-5">
          <div className="row">
            <div className="form-group col-md-6 mb-3">
              <label className="customLabel">
                Select Plan <span className="fieldMandatory">*</span>
              </label>
              <select
                className="cateSelectbox"
                value={selectedPlan?.id || ""}
                onChange={handlePlanChange}
              >
                <option disabled value="">
                  Select Plan
                </option>
                {smallBusinessPlansSelector &&
                  smallBusinessPlansSelector.map((plan) => (
                    <option key={plan.id} value={plan.id}>
                      {plan.name}
                    </option>
                  ))}
              </select>
            </div>
          </div>
        </form>

        {selectedPlan && (
          <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">{selectedPlan.name}</h5>
              <div>
                {!editMode && (
                  <button
                    className="submitBtn"
                    onClick={handleEditToggle}
                    type="button"
                  >
                    <FontAwesomeIcon icon={faEdit} className="me-1" />
                    Edit
                  </button>
                )}
              </div>
            </div>

            <form className="form">
              <div className="row">
                {!editMode ? (
                  <>
                    <div className="form-group col-md-6 mb-3">
                      <label className="customLabel">Name</label>
                      <input
                        type="text"
                        className="customFormControl"
                        value={selectedPlan.name || ""}
                        disabled
                      />
                    </div>
                    <div className="form-group col-md-6 mb-3">
                      <label className="customLabel">
                        {isProduction ? "Production" : "Development"} Price ID{" "}
                      </label>
                      <input
                        disabled
                        type="text"
                        className="customFormControl"
                        name={isProduction ? "price_id" : "dev_price_id"}
                        value={
                          isProduction
                            ? formData?.price_id
                            : formData?.dev_price_id
                        }
                        placeholder={`${
                          isProduction ? "Production" : "Development"
                        } Price ID`}
                      />
                    </div>

                    <div className="form-group col-md-12 mb-3">
                      <label className="customLabel">Description</label>
                      <textarea
                        className="customFormControl"
                        rows="3"
                        value={selectedPlan.description || ""}
                        disabled
                      ></textarea>
                    </div>
                    <div className="form-group col-md-4 mb-3">
                      <label className="customLabel">First Year Cost</label>
                      <input
                        type="text"
                        className="customFormControl"
                        value={selectedPlan.one_year_cost || 0}
                        disabled
                      />
                    </div>
                    <div className="form-group col-md-4 mb-3">
                      <label className="customLabel">Later Cost</label>
                      <input
                        type="text"
                        className="customFormControl"
                        value={selectedPlan.later_cost || 0}
                        disabled
                      />
                    </div>
                    <div className="form-group col-md-4 mb-3">
                      <label className="customLabel">Total Users</label>
                      <input
                        type="text"
                        className="customFormControl"
                        value={selectedPlan.total_users || 0}
                        disabled
                      />
                    </div>

                    <div className="form-group col-md-12 mb-3">
                      <div className="accordion" id="additionalInfoAccordion">
                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id="additionalInfoHeading"
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#additionalInfoCollapse"
                              aria-expanded="false"
                              aria-controls="additionalInfoCollapse"
                            >
                              <span className="customLabel mb-0">
                                Additional Information
                              </span>
                            </button>
                          </h2>
                          <div
                            id="additionalInfoCollapse"
                            className="accordion-collapse collapse"
                            aria-labelledby="additionalInfoHeading"
                          >
                            <div className="accordion-body p-0">
                              {additionalInfoItems.length > 0 ? (
                                <ul className="list-group list-group-flush">
                                  {additionalInfoItems.map((item) => (
                                    <li
                                      key={item.id}
                                      className="list-group-item d-flex justify-content-between align-items-center"
                                    >
                                      <span
                                        style={{
                                          fontWeight: item.is_bold
                                            ? "bold"
                                            : "normal",
                                        }}
                                      >
                                        {item.info}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              ) : selectedPlan.extra_data &&
                                !Array.isArray(selectedPlan.extra_data) ? (
                                <div className="p-3">
                                  <pre className="mb-0">
                                    {JSON.stringify(
                                      selectedPlan.extra_data,
                                      null,
                                      2
                                    )}
                                  </pre>
                                </div>
                              ) : (
                                <div className="text-center p-3">
                                  <p className="mb-0">
                                    No additional information available
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="form-group col-md-6 mb-3">
                      <label className="customLabel">
                        Name <span className="fieldMandatory">*</span>
                      </label>
                      <input
                        type="text"
                        className="customFormControl"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Plan Name"
                      />
                    </div>
                    <div className="form-group col-md-6 mb-3">
                      <label className="customLabel">
                        {isProduction ? "Production" : "Development"} Price ID{" "}
                        <span className="fieldMandatory">*</span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>This is the price ID from Stripe</Tooltip>
                          }
                        >
                          <span className="ms-1">
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              className="me-1"
                            />
                          </span>
                        </OverlayTrigger>
                      </label>
                      <input
                        type="text"
                        className="customFormControl"
                        name={isProduction ? "price_id" : "dev_price_id"}
                        value={
                          isProduction
                            ? formData?.price_id
                            : formData?.dev_price_id
                        }
                        onChange={handleInputChange}
                        placeholder={`${
                          isProduction ? "Production" : "Development"
                        } Price ID`}
                      />
                    </div>

                    <div className="form-group col-md-12 mb-3">
                      <label className="customLabel">Description</label>
                      <textarea
                        className="customFormControl"
                        rows="3"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        placeholder="Plan Description"
                      ></textarea>
                    </div>
                    <div className="form-group col-md-4 mb-3">
                      <label className="customLabel">
                        First Year Cost{" "}
                        <span className="fieldMandatory">*</span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              If you update price here, update on Stripe
                              dashboard too
                            </Tooltip>
                          }
                        >
                          <span className="ms-1">
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              className="me-1"
                            />
                          </span>
                        </OverlayTrigger>
                      </label>
                      <input
                        type="number"
                        className="customFormControl"
                        name="one_year_cost"
                        value={formData.one_year_cost}
                        onChange={handleInputChange}
                        placeholder="First Year Cost"
                      />
                    </div>
                    <div className="form-group col-md-4 mb-3">
                      <label className="customLabel">
                        Later Cost <span className="fieldMandatory">*</span>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip>
                              If you update price here, update on Stripe
                              dashboard too
                            </Tooltip>
                          }
                        >
                          <span className="ms-1">
                            <FontAwesomeIcon
                              icon={faInfoCircle}
                              className="me-1"
                            />
                          </span>
                        </OverlayTrigger>
                      </label>
                      <input
                        type="number"
                        className="customFormControl"
                        name="later_cost"
                        value={formData.later_cost}
                        onChange={handleInputChange}
                        placeholder="Later Cost"
                      />
                    </div>
                    <div className="form-group col-md-4 mb-3">
                      <label className="customLabel">
                        Total Users <span className="fieldMandatory">*</span>
                      </label>
                      <input
                        type="number"
                        className="customFormControl"
                        name="total_users"
                        value={formData.total_users}
                        onChange={handleInputChange}
                        placeholder="Total Users"
                      />
                    </div>

                    <div className="form-group col-md-12 mb-3">
                      <div
                        className="accordion"
                        id="additionalInfoAccordionEdit"
                      >
                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id="additionalInfoHeadingEdit"
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#additionalInfoCollapseEdit"
                              aria-expanded="false"
                              aria-controls="additionalInfoCollapseEdit"
                            >
                              <span className="customLabel mb-0">
                                Additional Information
                              </span>
                            </button>
                          </h2>
                          <div
                            id="additionalInfoCollapseEdit"
                            className="accordion-collapse collapse"
                            aria-labelledby="additionalInfoHeadingEdit"
                          >
                            <div className="accordion-body p-0">
                              {additionalInfoItems.length > 0 ? (
                                <ul className="list-group list-group-flush">
                                  {additionalInfoItems.map((item, index) => (
                                    <li
                                      key={index}
                                      className="list-group-item d-flex justify-content-between align-items-center"
                                    >
                                      {editingInfoItem &&
                                      editingInfoItem?.index === index ? (
                                        <div
                                          className="accordion w-100"
                                          id={`accordion-${index}`}
                                        >
                                          <div className="accordion-item border-0">
                                            <div className="accordion-body p-0">
                                              <div className="row">
                                                <div className="form-group col-md-8 mb-2">
                                                  <input
                                                    type="text"
                                                    className="customFormControl"
                                                    value={
                                                      editingInfoItem?.info
                                                    }
                                                    onChange={
                                                      handleInfoItemChange
                                                    }
                                                    placeholder="Item text"
                                                  />
                                                </div>
                                                <div className="form-group col-md-4 mb-2">
                                                  <div className="d-flex align-items-center">
                                                    <div className="form-check form-switch">
                                                      <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`boldSwitch-${index}`}
                                                        checked={
                                                          editingInfoItem.is_bold
                                                        }
                                                        onChange={
                                                          handleInfoItemBoldToggle
                                                        }
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor={`boldSwitch-${index}`}
                                                      >
                                                        Bold
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="d-flex justify-content-end mt-2">
                                                <button
                                                  type="button"
                                                  className="submitBtn btn-sm"
                                                  onClick={handleUpdateInfoItem}
                                                >
                                                  Save
                                                </button>
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-secondary btn-sm ms-2"
                                                  onClick={() =>
                                                    setEditingInfoItem(null)
                                                  }
                                                >
                                                  Cancel
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        <span
                                          style={{
                                            fontWeight: item?.is_bold
                                              ? "bold"
                                              : "normal",
                                          }}
                                        >
                                          {item?.info}
                                        </span>
                                      )}

                                      {!editingInfoItem && (
                                        <div>
                                          <img
                                            src={Images.editIcon}
                                            alt="Edit"
                                            className="trashIcon me-2"
                                            onClick={() =>
                                              handleEditInfoItem(item, index)
                                            }
                                            style={{ cursor: "pointer" }}
                                          />
                                          <img
                                            src={Images.deletedicon}
                                            alt="Delete"
                                            className="trashIcon"
                                            onClick={() =>
                                              handleDeleteInfoItem(index)
                                            }
                                            style={{ cursor: "pointer" }}
                                          />
                                        </div>
                                      )}
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <div className="text-center p-3">
                                  <p className="mb-0">
                                    No additional information items
                                  </p>
                                </div>
                              )}

                              {!editingInfoItem && !showAddForm && (
                                <div className="p-3 border-top">
                                  <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={() => setShowAddForm(true)}
                                  >
                                    <i className="las la-plus"></i> Add Item
                                  </button>
                                </div>
                              )}

                              {showAddForm && (
                                <div className="p-3 border-top">
                                  <div className="row">
                                    <div className="form-group col-md-8 mb-2">
                                      <input
                                        type="text"
                                        className="customFormControl"
                                        value={newInfoItem.text}
                                        onChange={handleNewInfoItemChange}
                                        placeholder="New item text"
                                      />
                                    </div>
                                    <div className="form-group col-md-4 mb-2">
                                      <div className="d-flex align-items-center">
                                        <div className="form-check form-switch">
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            id="newItemBoldSwitch"
                                            checked={newInfoItem.is_bold}
                                            onChange={
                                              handleNewInfoItemBoldToggle
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="newItemBoldSwitch"
                                          >
                                            Bold
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="d-flex justify-content-end mt-2">
                                    <button
                                      type="button"
                                      className="submitBtn btn-sm"
                                      onClick={handleAddInfoItem}
                                    >
                                      Add
                                    </button>
                                    <button
                                      type="button"
                                      className="btn btn-outline-secondary btn-sm ms-2"
                                      onClick={() => setShowAddForm(false)}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </form>

            {editMode && (
              <div className="col-12 d-flex justify-content-end mt-3">
                <button
                  className="submitBtn"
                  type="button"
                  onClick={handleSave}
                >
                  {loading && (
                    <span className="spinner-border spinner-border-sm"></span>
                  )}
                  Save
                </button>
              </div>
            )}
          </div>
        )}

        {!selectedPlan && !loading && (
          <div className="text-center p-4">
            <p>No plan selected or available</p>
          </div>
        )}
      </div>
    </>
  );
};

export default SmallUserPlans;
